import { useState, useContext, useEffect, useRef } from "react";
import styles from "./styles/PosTicketResult.module.css";
import Carousel from "../../../components/ui/carousel/Carousel";
import Button from "../../../components/ui/button/Button";
import useWindowSize from "../../../hooks/useWindowSize";
import useRefDimensions from "../../../hooks/useRefDimensions";
import POSDataContext from "../../../context/POSDataContext";
import { t } from "i18next";

/**
 * PhotoPanel component
 */
const PosPhotoPanel = ({
    ticket, // {Object} - The ticket data object
}) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const windowSize = useWindowSize(); // Hook to calculate window's size
    const carouselRef = useRef(null);
    const carouselSize = useRefDimensions(carouselRef); // Hook to calculate the carousel's size
    const {
        currentCategoryPos, // {String} - The current category (default is the first one if avialable)
        setCurrentCategoryPos, // {Function} - Function to set the current category in POS module
    } = useContext(POSDataContext);

    // Check for full screen
    useEffect(() => {
        const checkFullscreen = () => {
            const isFullscreen =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            setIsFullscreen(!!isFullscreen);
        };

        document.addEventListener("fullscreenchange", checkFullscreen);
        document.addEventListener("webkitfullscreenchange", checkFullscreen);
        document.addEventListener("mozfullscreenchange", checkFullscreen);
        document.addEventListener("MSFullscreenChange", checkFullscreen);

        // Full screen initial check
        checkFullscreen();

        return () => {
            document.removeEventListener("fullscreenchange", checkFullscreen);
            document.removeEventListener(
                "webkitfullscreenchange",
                checkFullscreen
            );
            document.removeEventListener(
                "mozfullscreenchange",
                checkFullscreen
            );
            document.removeEventListener("MSFullscreenChange", checkFullscreen);
        };
    }, []);

    /**
     * Category handle
     * Set the cauurent photo category
     */
    const handleCategory = (event) => {
        setCurrentCategoryPos(event.target.value);
    };

    /**
     * Return all the categories for the current ticket
     */
    /**
     *
     * @param {Object} obj - The ticket data object
     * @returns {Array} - the names of the categories
     */
    const getCategories = (obj) => {
        const tempCategories = [];
        obj?.map((photo) => {
            !tempCategories.includes(photo?.category) &&
                tempCategories.push(photo?.category);
        });
        return tempCategories;
    };

    return (
        <section
            className={` ${styles.main_photo_container} `}
            ref={carouselRef}
        >
            <div className={`${styles.categories_container} `}>
                {getCategories(ticket?.photos).map((category, idx) => (
                    <Button
                        key={category}
                        body={t(category)}
                        size={"small"}
                        type={"button"}
                        onClickFuction={handleCategory}
                        active={currentCategoryPos === category}
                    />
                ))}
            </div>
            <div className={`${styles.carousel_container} `}>
                <Carousel
                    images={ticket?.photos
                        ?.filter(
                            (photo) => photo?.category === currentCategoryPos
                        )
                        ?.map((photo) => {
                            return {
                                original: photo?.picture,
                                thumbnail: photo?.picture,
                                originalAlt: `Evidence photo, category ${currentCategoryPos}`,
                                thumbnailAlt: `Evidence photo, category ${currentCategoryPos}`,
                                // calculate the photo size (31% of nthe carousel size)
                                // only if not in full screen
                                originalHeight: !isFullscreen
                                    ? carouselSize.width -
                                      (carouselSize.width * 31) / 100
                                    : null,
                            };
                        })}
                    // show thumbnails only on resolution more than 768
                    showThumbnails={
                        isFullscreen || windowSize.width <= 768 ? false : true
                    }
                    // show bullets only on resolution less than 768
                    showBullets={
                        isFullscreen || windowSize.width <= 768 ? true : false
                    }
                />
            </div>
        </section>
    );
};

export default PosPhotoPanel;
